import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../service/api/api.service';
import { SocketService } from '../../../service/sio/socket.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  // providers:[SocketService]
})
export class SidebarComponent implements OnInit {
  userConneceted: any
  constructor(public api: ApiService, public sio: SocketService) {

  }
  ngOnInit(): void {
    this.userConneceted = this.api.token.user_connected
    console.log("id_employe == ", this.userConneceted.id_employe)
    this.sio.on_update((data: any) => {
      //console.log('on_change(after_add_commande,after_edit_une_commande ', data)
      this.api.les_utilisateurs = data.map((un_utilisateur: any) => {
        un_utilisateur.icone = "bx-user"
        if (un_utilisateur.token) {
          un_utilisateur.token_decoded = this.api.decode_token(un_utilisateur.token)
          un_utilisateur.titre = "E°" + un_utilisateur?.token_decoded?.user_connected?.id_employe + "-" + un_utilisateur?.token_decoded?.user_connected?.prenom + " " + un_utilisateur?.token_decoded?.user_connected?.nom
          un_utilisateur.moi = un_utilisateur?.token_decoded?.user_connected?.id_employe == this.userConneceted.id_employe
        } else {
          un_utilisateur.titre = "Inconnu"
        }
        return un_utilisateur
      })
      //console.log("les_utilisateurs = ", this.api.les_utilisateurs)
    });
  }
}
